<!-- フッター -->
<div class="footer p-jc-center">
  <!-- サイト名 -->
  <div class="footer-text">{{ title }}</div>
  <!-- ホームページ -->
  <div class="home p-d-flex p-jc-center">
    <!-- ホームページテキスト -->
    <div class="homeText">
      <a href="https://future-city.go.jp/platform/">ホームページ</a>
    </div>
  </div>
  <!-- 開設日 -->
  <div class="opening-date" lang="en">{{ openingDate }}</div>
</div>

<!-- スクロールボタン -->
<button
  id="pageTopButton"
  pButton
  type="button"
  icon="pi pi-arrow-up"
  (click)="transitionPageTop()"
  class="p-button-raised p-button-rounded page_top"
  disabled
></button>
